<ng-container *ngIf="!loading; else loadingBlock">
  <ng-container *ngIf="promotions.length > 0">
    <div class="card-list">
      <div class="card-list--header" *ngIf="content.title">
        <air-title [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
      </div>

      <ul class="card-list--promotion grid">
        <li *ngFor="let p of promotions" class="card col-4 col-3--md col-4--sm">
          <a
            [airLink]="
              hasAlternativeTarget(p.promotion) && p.promotion.alternativeTarget ? p.promotion.alternativeTarget[0] : p.promotion.url
            "
            [userEventSource]="userEventSource"
            [userEventLabel]="p.promotion.title"
            [userEventObject]="p.userEventObject"
          >
            <div class="card__image">
              <figure *ngIf="p.promotion.image">
                <air-focal-image [image]="p.promotion.image"></air-focal-image>
              </figure>
            </div>
            <div *ngIf="p.promotion.points" class="card__stickers">
              <air-miles-sticker [size]="'md'" [points]="p.promotion.points"></air-miles-sticker>
            </div>

            <div class="card__text">
              <h4>{{ p.promotion.title }}</h4>
              <div *ngIf="p.promotion.validTo" class="card__description">
                <p>{{ activationLabel(p.promotion) }}: {{ p.promotion.validTo | date: "dd-MM-yyyy" }}</p>
              </div>
            </div>
            <div class="card__cta d--none--md">
              <a
                class="button"
                [ngClass]="{
                  'button--cta': p.promotion.requiresActivation && !p.promotion.isActivated,
                  'button--border button--transparent': !p.promotion.requiresActivation || p.promotion.isActivated
                }"
                [airLink]="
                  hasAlternativeTarget(p.promotion) && p.promotion.alternativeTarget ? p.promotion.alternativeTarget[0] : p.promotion.url
                "
              >
                <span>{{ buttonLabel(p.promotion) }}</span>
              </a>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </ng-container>
</ng-container>

<ng-template #loadingBlock>
  <div class="loading">
    <ul class="card-list card-list--promotion grid loading">
      <li class="col-4 col-3--md col-4--sm" *ngFor="let skeleton of [] | range: 3">
        <air-skeleton-card></air-skeleton-card>
      </li>
    </ul>
  </div>
</ng-template>
